import {Component, Input, OnInit} from '@angular/core';
import {ShipmentDetailsModel} from '../../@shared/models/shipment-details.model';

@Component({
    selector: 'shipment-responsive-card',
    templateUrl: './shipment-responsive-card.component.html',
    styleUrls: ['./shipment-responsive-card.component.scss']
})
export class ShipmentResponsiveCardComponent implements OnInit {

    @Input() shipmentDetails: ShipmentDetailsModel;

    constructor() {
    }

    ngOnInit(): void {
    }

}
